import type { MaterialLineItemOption } from "../types";

export function findOptionForProductId(
    options: MaterialLineItemOption[],
    productId: string | null | undefined,
): MaterialLineItemOption | null {
    if (!productId) return null;
    return (
        options.find(
            (option) =>
                option.ProductId === productId ||
                option.Variants?.some((variant) => variant.ProductId === productId),
        ) ?? null
    );
}

export function getColorForProductId(
    options: MaterialLineItemOption[],
    productId: string | null | undefined,
): string | null {
    if (!productId) return null;
    for (const option of options) {
        const variant = option.Variants?.find((entry) => entry.ProductId === productId);
        if (variant?.Color) return variant.Color;
    }
    return null;
}

/** Resolve concrete SKU for a size option + optional catalog color. */
export function resolveVariantProductId(
    option: MaterialLineItemOption | null | undefined,
    color: string | null | undefined,
): string | null {
    if (!option) return null;

    const variants = option.Variants ?? [];
    if (color) {
        const colored = variants.find((variant) => variant.Color === color);
        if (colored) return colored.ProductId;
    }

    const uncolored = variants.find((variant) => !variant.Color);
    if (uncolored) return uncolored.ProductId;

    return variants[0]?.ProductId ?? option.ProductId ?? null;
}

export function findOptionByKey(
    options: MaterialLineItemOption[],
    optionKey: string | null | undefined,
): MaterialLineItemOption | null {
    if (!optionKey) return null;
    return options.find((option) => option.OptionKey === optionKey) ?? null;
}
